export default angular.module('eventix.common.directives.jsonEditor',[])
    /**
     * @ngdoc directive
     * @name eventix.common.directives:jsonEditor
     * @restrict element
     * @description
     * Show JSON data in a table where the cells are editable
     *
     * @param {Object|Array} data Data to show/edit
     */
    .component('jsonEditor', {
        template: `<div ng-show="$ctrl.subtree" class="btn-group clear">
    <a class="btn btn-info" ng-click="$ctrl.ascend()" translate>common.action.back</a>
    <span class="btn btn-white">{{ $ctrl.formatPath() }}</span>
</div>
<table ng-show="$ctrl.keys" class="table form-inline">
    <thead>
        <th ng-repeat="key in $ctrl.keys"> {{ key | humanize }} </th>
        <th width="50"></th>
    </thead>
    <tbody>
        <tr ng-repeat="row in $ctrl.makeArray($ctrl.root) | startFrom:$ctrl.page * $ctrl.pageSize | limitTo:$ctrl.pageSize">
            <td ng-repeat="key in $ctrl.keys" ng-init="tr={}">
                <span class="pull-right" uib-dropdown>
                    <a class="btn btn-xs btn-link" uib-dropdown-toggle><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu" uib-dropdown-menu>
                        <li><a ng-click="$ctrl.setType(row, key, 'Replace this text')">String</a></li>
                        <li><a ng-click="$ctrl.setType(row, key, 1)">Number</a></li>
                        <li><a ng-click="$ctrl.setType(row, key, true)">Boolean</a></li>
                        <li><a ng-click="$ctrl.setType(row, key, null)">Null</a></li>
                    </ul>
                </span>
                <div ng-click="tr.edit=true;$ctrl.focus($event)"
                     ng-show="($ctrl.isNumber(row[key]) || $ctrl.isString(row[key])) && !tr.edit">
                        {{ row[key] }}
                </div>
                <div class="monospace" ng-click="$ctrl.descend(row, key)" ng-show="$ctrl.isObject(row[key]) || $ctrl.isNil(row[key])">
                    {{ $ctrl.maxLength(row[key] | debug:null, 40)  }}
                </div>
                <toggle-el ng-model="row[key]" ng-if="$ctrl.isBoolean(row[key])"></toggle-el>
                <div ng-show="tr.edit">
                    <input type="text"
                           ng-if="$ctrl.isString(row[key]) || $ctrl.isNil(row[key])"
                           ng-blur="tr.edit=false"
                           ng-keydown="$ctrl.closeOnEnter($event, tr)"
                           ng-model="row[key]"
                           class="form-control input-sm">
                    <input type="number"
                           ng-if="$ctrl.isNumber(row[key])"
                           ng-blur="tr.edit=false"
                           ng-keydown="$ctrl.closeOnEnter($event, tr)"
                           ng-model="row[key]"
                           class="form-control input-sm">
                </div>
            </td>
            <td>
                <a class="btn btn-link btn-xs"
                   ng-click="$ctrl.deleteRow(row)" ng-show="$ctrl.isArray($ctrl.root)">
                    <i class="fa fa-trash-o"></i></a>
            </td>
        </tr>
    </tbody>
</table>
<div class="text-center" ng-show="$ctrl.root.length > $ctrl.pageSize">
    <div class="btn-group">
        <a class="btn btn-default" ng-click="$ctrl.prev()" translate>Prev</a>
        <button class="btn btn-white" disabled>{{ $ctrl.page + 1 }}</button>
        <a class="btn btn-default" ng-click="$ctrl.next()" translate>Next</a>
    </div>
</div>`,
        controller: JSONEditorController,
        bindings: {
            data: '='
        }
    }).name;

function JSONEditorController($scope, $timeout, $filter, ConfirmDelete) {
    const $ctrl = this;

    $ctrl.$onInit = function() {
        $ctrl.page = 0;
        $ctrl.pageSize = 25;
        $scope.$watch('$ctrl.data', data => {
            if(!angular.isArray(data) && !angular.isObject(data)) {
                $ctrl.keys = null;
                return;
            }
            $ctrl.root = data;
            $ctrl.subtree = null;
            $ctrl.page = 0;
            $ctrl.keys = getAllKeys(angular.isArray($ctrl.root) ? $ctrl.root : [$ctrl.root]);
        });
    };

    $ctrl.deleteRow = function(row) {
        if(angular.isArray($ctrl.root)) {
            let index = _.indexOf($ctrl.root, row);
            if(index < 0)
                return;
            ConfirmDelete.open('row')
                .then(() => {
                    $ctrl.root.splice(index, 1);
                    $scope.$emit('jsonEditor.deleteRow', $ctrl.subtree, index, row);
                }, angular.noop);
        }
    };

    $ctrl.closeOnEnter = function(event, row) {
        if(event.which === 13)
            row.edit = false;
    };

    $ctrl.setType = function(row, key, type) {
        row[key] = type;
    };

    $ctrl.makeArray = function(input) {
        return angular.isArray(input) ? input : [input];
    };

    $ctrl.maxLength = function(input, max, cutOffSymbol = '\u2026') {
        if(!angular.isString(input) || input.length <= max)
            return input;
        return input.slice(0, max - 1) + cutOffSymbol;
    };

    $ctrl.formatPath = function() {
        if(!$ctrl.subtree) return '';
        let humanize = $filter('humanize');
        return $ctrl.subtree.map(humanize).join(' > ');
    };

    $ctrl.descend = function(row, key) {
        if($ctrl.isNil(row[key]))
            return;
        $ctrl.subtree = $ctrl.subtree || [];
        if(angular.isArray($ctrl.root))
            $ctrl.subtree.push($ctrl.root.indexOf(row));
        $ctrl.subtree.push(key);
        $ctrl.root = row[key];
        $ctrl.page = 0;
        $ctrl.keys = getAllKeys(angular.isArray($ctrl.root) ? $ctrl.root : [$ctrl.root]);
    };

    $ctrl.ascend = function() {
        $ctrl.subtree.pop();
        if(!$ctrl.subtree.length)
            $ctrl.subtree = null;
        else if(angular.isNumber($ctrl.subtree.slice(-1)[0]))
            return $ctrl.ascend();
        $ctrl.root = $ctrl.subtree ? _.get($ctrl.data, $ctrl.subtree) : $ctrl.data;
        $ctrl.page = 0;
        $ctrl.keys = getAllKeys(angular.isArray($ctrl.root) ? $ctrl.root : [$ctrl.root]);
        return true;
    };

    $ctrl.isArray = (v) => angular.isArray(v);
    $ctrl.isNumber = (v) => angular.isNumber(v);
    $ctrl.isString = (v) => angular.isString(v);
    $ctrl.isBoolean = (v) => typeof v === 'boolean';
    $ctrl.isNil = (v) => v === null || v === undefined;
    $ctrl.isObject = (v) => angular.isObject(v);

    $ctrl.focus = function(event) {
        $timeout(() => angular.element(event.currentTarget).parent().find('input:visible').focus());
    };

    $ctrl.prev = () => {
        if($ctrl.page > 0)
            $ctrl.page--;
    };

    $ctrl.next = () => {
        if(($ctrl.page + 1) * $ctrl.pageSize < $ctrl.root.length)
            $ctrl.page++;
    };
}

function getAllKeys(data) {
    let keys = data.reduce((keys, row) => keys.concat(Object.keys(row)), []);
    let uniqKeys = [];
    keys.forEach(key => {
        if(uniqKeys.indexOf(key) < 0 && !/^\$/.test(key))
            uniqKeys.push(key);
    });
    return uniqKeys;
}
